import styled from '@emotion/styled';

import Popover from '@mui/material/Popover';

const StyledPopover = styled(Popover)`
  padding: 100px;
  .popover-button {
     background-color: #FAFAFA;
     color: #161728;

     &.Mui-selected,:active,:hover {
      background-color: black;
      color: white;
    }
  }
  
`;

export default StyledPopover;
